import { render, staticRenderFns } from "./search-tag-dropdown.vue?vue&type=template&id=34c835a8&"
import script from "./search-tag-dropdown.vue?vue&type=script&lang=ts&"
export * from "./search-tag-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./search-tag-dropdown.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports